import { ClassProps } from "@/lib/types/class-props";
import React from "react";
import BaseSkeleton from "../base-skeleton";
import Skeleton from "../skeleton";

export type ListTileSkeletonProps = ClassProps;

const ListTileSkeleton = ({ className }: ListTileSkeletonProps) => {
  return (
    <div
      className={`flex justify-between lg:grid grid-cols-3 lg:grid-cols-7 2xl:grid-cols-6 gap-3 items-center w-full rounded-2xl ${className}`}
    >
      {/* Image and text */}
      <div className="flex space-x-4 items-center lg:col-span-3 2xl:col-span-2 w-[80%] truncate py-3 pl-3 lg:py-5 lg:pl-5">
        <BaseSkeleton className="w-[64px] h-[52px] lg:w-[99px] lg:h-[81px] rounded-xl" />

        <div className="flex flex-col space-y-1 items-start justify-between w-[50%] lg:w-2/3">
          <BaseSkeleton className="w-[100px] h-[24px] rounded-xl" />

          <Skeleton size="sm" />
        </div>
      </div>

      {/* Tempo */}
      <div className="hidden lg:flex justify-between col-span-2">
        <Skeleton size="sm" />
      </div>

      {/* Add to cart button */}
      <div className="space-x-5 py-3 lg:py-5 pr-3 lg:pr-5 items-center flex justify-end col-span-2">
        {/* <Icon icon={Heart} /> */}

        <BaseSkeleton className="rounded-full w-[100px] h-8" />
      </div>
    </div>
  );
};

export default ListTileSkeleton;
